import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'createNumericLabel',
})
export class CreateNumericLabelPipe implements PipeTransform {
  private displayNoDataMessage: boolean = false;

  constructor(private decimalFormatterPipe: DecimalPipe) {}

  transform(value: number, displayNoDataMessage: boolean, ensurePositiveNumericValue: boolean = false): string {
    this.displayNoDataMessage = displayNoDataMessage;

    if (ensurePositiveNumericValue) {
      return this.createPositiveNumericLabel(value);
    }

    return this.createNumericLabel(value);
  }

  private createNumericLabel(value: number): string {
    return value == null || isNaN(value) || !isFinite(value) ? this.getDefaultMessage() : this.decimalFormatterPipe.transform(value, '1.1-5');
  }

  private getDefaultMessage(): string {
    if (this.displayNoDataMessage) {
      return 'No Data';
    }

    return '';
  }

  private createPositiveNumericLabel(value: number): string {
    const positiveValue = this.convertNegativeValueToZero(value);

    return this.createNumericLabel(positiveValue);
  }

  private convertNegativeValueToZero(value: number): number {
    return value < 0 ? 0 : value;
  }
}
